<template>
  <section id="contato">
    <div class="container">
      <title-vue title="Contato" />
      <CardExperienceVue :information="informations" />
    </div>
  </section>
</template>

<script>
import TitleVue from "@/components/General/Title/Title.vue";
import emailjs from "@emailjs/browser";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
import { ref } from "vue";
import CardExperienceVue from "@/components/Experience/CardExperience.vue";

export default {
  name: "ContactView",
  setup() {
    let templateParams = ref({
      user_name: "",
      user_email: "",
      subject: "",
      message: "",
    });

    const informations = {
      role: "joaovictoroliveirapereira@gmail.com",
      company: "+55 71 8168-9962",
    };

    async function sendMail() {
      await emailjs
        .send(
          "service_87trsoi",
          "template_fj6hvwa",
          templateParams.value,
          "EzP45N3mscKhPFXq2"
        )
        .then((response) => {
          if (response.status === 200) {
            document.querySelector("form").reset();
            return createToast(
              "Envio feito com sucesso! Irei te responder assim que possível!",
              {
                type: "success",
                position: "bottom-center",
              }
            );
          }
        })
        .catch(() => {
          return createToast("Erro no envio", {
            type: "warning",
            position: "bottom-center",
          });
        });
    }
    return { sendMail, templateParams, informations };
  },
  components: {
    TitleVue,
    CardExperienceVue,
  },
};
</script>

<style scoped>
div * {
  display: block;
}
form {
  display: flex;
  flex-direction: column;
  align-items: center;
}
label {
  font-family: "Montserrat";
  color: var(--color-text);
  margin-bottom: 0.625rem;
}

textarea {
  width: 300px;
  border: 3px solid #000;
  background-color: transparent;
  color: var(--color-text);
  font-size: var(--fs-text-2);
}

button {
  color: var(--color-text-buttons);
  width: 200px;
  padding: 10px 0;
  background: var(--bg-buttons);
  text-align: center;
  font-size: var(--fs-text-buttons);
  font-family: "Segoe UI";
  margin-top: 2.5rem;
  display: block;
  transition: all 0.3s;
  cursor: pointer;
  border: 3px solid #000;
}

button:hover {
  color: #707070;
  background: #fff;
}
</style>
